import script from "./SurveyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyForm.vue?vue&type=script&setup=true&lang=js"

import "./SurveyForm.vue?vue&type=style&index=0&id=097eb1ac&lang=scss"

const __exports__ = script;

export default __exports__